module.exports = __webpack_public_path__ + "media/images/emblems/Aarwangen-coat_of_arms-cafde5d726626f6c02b441a07425490a.svg";